import Main from "../components/Main";
import React from "react";

export default () => (
  <Main noLeftNav>
    <p>You've been logged out successfully.</p>
  </Main>
);
